import React from 'react'
import Database from '../components/Databases/Index'

const Databases = () => {
  return (
    <div className='container mx-auto'><Database/></div>
  )
}

export default Databases